<template>
<div>
  <!-- div wrapper is required for router to properly function with model -->
  <div class="ui small modal" id="loginModal">


    <div class="header">
      BIOveikals
    </div>
    <div class="content">
      <div class="ui middle aligned grid">
        <div class="column">
          <div v-if="storeStatus.error != ''" class="ui negative message">
            Pārbaudi e-pastu un paroli!
          </div>
          <div class="ui  center aligned  form">

            <div class="ui  segment">
              <div class="field">
                <div class="ui left icon input">
                  <i class="user icon"></i>
                  <input v-model="credentials.email" type="email" placeholder="E-pasts">
                </div>
              </div>
              <div class="field">
                <div class="ui left icon input">
                  <i class="lock icon"></i>
                  <input v-model="credentials.password" type="password" placeholder="Parole" @keyup.enter="login">
                </div>
              </div>
              <button v-on:click="login" :disabled="credentials.email == '' || credentials.password == ''" class="ui fluid large custom_brown button" v-bind:class="{ loading: storeStatus.loading }">Autorizēties</button>
              <p class="ms-reset-password-link">
              <a @click="goToResetPage" >Atjaunot paroli</a>
            </p>
            </div>
          </div>
          <div class="ui horizontal divider">
            Vai
          </div>
          <div class="ui segment">
          <div class="ui fluid custom_brown button" @click="goToRegistratinPage">
            Jauns Klients

          </div>
        </div>

        <div class="ui horizontal divider">
            Vai
          </div>
          <div class="ui segment">
            <div class="ui fluid green button" @click="createGuestToken">
              Atcelt
            </div>

         </div>



    <!--
          <div class="ui message">
            <p>Neesi mūsu klients? <a v-on:click="goToRegistratinPage" class="ms-pointer">Reģistrējies šeit</a></p>
          </div>

        -->
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {

  data() {
    return {
      credentials: {
        email: '',
        password: '',
        cartid: '',
      },
      showModal:true,
      nextPage:'home' //see below
    }
  },

  computed: {
    storeStatus() {
      return this.$store.state.userStore.status
    },
    cart() {
      //huiohuio
        return this.$store.state.cartStore.activeCart
    },
  },


  activated: function() {

    this.nextPage = 'home';
    var self = this;

    this.$store.dispatch('loadUser').then((response) => {

        //if guest opens login page then end his session
        if(response.data.user.role == 0){
          this.showLoginPage()
          //this.$store.dispatch('logoutUser');

        }
        else {
        $('#loginModal').modal('hide all');
        //go to home page

          this.$router.push({
            name: self.getNextPage()
          });
        }

    }).catch((error) => {
      //console.log(22)
      //clear previous token and user data
      //this.$store.dispatch('logoutUser');
      this.showLoginPage()
    });



  },


  methods: {
    showLoginPage(){
      var self = this;

      $('#loginModal')
        .modal({
          blurring: true,
          onHidden: function(){

            self.$router.push({
              name: self.getNextPage()
            });

          },
        })
        .modal('setting', 'closable', false)
        .modal('show');
    },

    getNextPage(){
      return this.nextPage
    },

    goToResetPage(){
      //set next page and hide so that hide event would move us to next page (due to semanticu ui issue with modal)
        this.nextPage = 'reset-password';
        $('#loginModal').modal('hide all');
    },

    createGuestToken(){
      //check if guest token exists and if yes then close login page

        this.$store.dispatch('loadUser').then((response) => {

          //hide (this will trigger redirect to home page )
          $('#loginModal').modal('hide all');

          }).catch((error) => {
            //if does not exists then reset token
            this.$store.dispatch('createGuestToken').then((response) => {
              //hide (this will trigger redirect to home page )
              $('#loginModal').modal('hide all');

            });
          });

    },

    login: function() {
      if(this.credentials.email == '' || this.credentials.password == '') return; //dont submit empty

      //add guest cart Id
      this.credentials.cartid = (this.cart && this.cart.id) ? this.cart.id : 0;

      this.$store.dispatch('loginUser', this.credentials).then((response) => {
        this.credentials.email = ""; //reset credentials so that they dont hang in local component state
        this.credentials.password = "";

        //load user and go to home page
        this.$store.dispatch('loadUser').then((response) => {
          //hide (this will trigger redirect to home page )
          $('#loginModal').modal('hide all');
        });

      }).catch((error) => {

      });
    },

    goToRegistratinPage: function() {
      var that=this;
      $('#loginModal').modal('hide');
      setTimeout(function() {
        that.$router.push({ name: 'new-user' });
      }, 600);
      setTimeout(function() {
        if (location.href.indexOf('new-user') == -1) {
          that.$router.push({ name: 'new-user' });
        }
      }, 3000);

      //var that=this;
      //this.$store.dispatch('createGuestToken').then((response) => {
      //   //hide (this will trigger redirect to home page )
      //   $('#loginModal').modal('hide');
      //    setTimeout(function(){
      //      that.$router.push({
      //      name: 'new-user'
      //    });
      //    },600)
      //    setTimeout(function(){
      //      if(location.href.indexOf('new-user')==-1){
      //        that.$router.push({
      //      name: 'new-user'
      //    });
      //      }
      //    },3000)
      //});

    }
  }

}
</script>

<style>
.ms-pointer {
  cursor: pointer;
}
.ms-reset-password-link {
  margin-top: 5px;
}
.ms-reset-password-link a {
  float: right;
}
</style>



// WEBPACK FOOTER //
// LoginPage.vue?0aa920a0